import React from 'react';
import _ from 'lodash';
import { Table, Pagination, Button, Menu, Input, Segment, Grid } from 'semantic-ui-react';
import { BaseURLDev, headers } from '../../../../../../_utils/config';  
import DetailOPD from './DetailOPD';
import { getOPD, getSKPD } from '../../../../../../_utils/localstorage';
import ModalEdit from './ModalEdit';
import swal from 'sweetalert';

export default class ListOPD extends React.Component {
   constructor(props){
      super(props);
      this.state = {
         column: null,
         data: null,
         direction: null,
         requests:true,
         isOpen:false,
         itemActive:{
            "nama":"",
            "username":"",
            "jabatan":"", 
            "created_at":"", 
            "public_id":""
         },
         action:null,
         is_edit:false,
         data_edit:null,
         loading_edit:false,
         activePage:1,
         totalPages:0,
         q:"",
         pageActive: 1
      }

      this.toggleModal = this.toggleModal.bind(this);
      this.onCloseEdit = this.onCloseEdit.bind(this);
      this.onOpenEdit = this.onOpenEdit.bind(this);
      this.resetPassword = this.resetPassword.bind(this);
      this.resetStatusActive = this.resetStatusActive.bind(this);
      this.searchOPD = this.searchOPD.bind(this);

   }

   onOpenEdit = (e, { index }) => {
      const { data } = this.state
      this.setState({
         is_edit:true,
         data_edit:data[index],
      });
   }

   onCloseEdit = () => {
      this.setState({
         is_edit:false,
         data_edit:null
      });
      this.onLoadOPD();
   }

   resetStatusActive = (e, {data}) => {
      this.setState({loading:true});
      fetch(`${BaseURLDev}/users/resetstatus`,{
         method: 'POST',
         body: JSON.stringify({username:data}),
         headers
      })
      .then(response => {
         if (!response.ok) { 
            swal("", "Update data status user OPD Error", "error");
            this.setState({loading:false,error:true});
            return Promise.reject(response.statusText);
         }
         return response.json();
      })
      .then(resJSON => {
         this.setState({loading:false});              
         swal({
            title: "Sukses!",
            text: `Status sekarang ${resJSON.data}`,
            icon: "success",
            button: "Ok",
         }).then(()=>{
            this.setState({loading:true});
            this.onLoadOPD();
         });               
      })
   }

   resetPassword = (e, {data}) => {
      this.setState({loading:true});
      fetch(`${BaseURLDev}/users/passwd?q=reset_password`,{
         method: 'POST',
         body: JSON.stringify({username:data}),
         headers
      })
      .then(response => {
         if (!response.ok) { 
            swal("", "Update data password gagal", "warning")
            this.setState({loading:false,error:true});
            return Promise.reject(response.statusText);
         }
         return response.json();
      })
      .then(resJSON => {
         this.setState({loading:false});              
         swal({
            title: "Sukses!",
            text: `Password sekarang ${resJSON.data}`,
            icon: "success",
            button: "Ok",
         }).then(()=>{
            this.setState({loading:true});
            this.onLoadOPD();
         });             
      })
   }
   
   onLoadOPD(){
      fetch(`${BaseURLDev}/users/opd`, {headers})
      .then(response => {
         if (!response.ok) { 
               return Promise.reject(response.statusText);
            }
         return response.json();
      })
      .then(resJSON => {
         this.setState({
            data:resJSON.data,
            requests:false,
            totalPages:resJSON.totalPage,
         })
      })
      .catch(e => {
            this.setState({
               requests:false,
            })
            swal("Mohon periksa koneksi internet anda\natau sedang terjadi gangguan di server\natau sedang terjadi gangguan di server", {
               icon: "error",
            });
      })
   }

   componentWillMount(){
      this.onLoadOPD();
   }

   searchOPD(e) {
      
      const q = e.target.value
      this.setState({q:q})   

      if(q.length===0){
         var url = `${BaseURLDev}/users/opd`
      }else{
         url = `${BaseURLDev}/users/opd?q=${q}`
      }

      fetch(url, { headers })
      .then(response => {
         if(!response.ok){
            window.alert("Load data gagal")               
            this.setState({data:[],requests:false});
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         this.setState({data:resJSON.data,totalPages:resJSON.totalPage})
      })
   
   }

   handleSort = clickedColumn => () => {
      const { column, data, direction } = this.state

      if (column !== clickedColumn) {
         this.setState({
            column: clickedColumn,
            data: _.sortBy(data, [clickedColumn]),
            direction: 'ascending',
         })

         return
      }

      this.setState({
         data: data.reverse(),
         direction: direction === 'ascending' ? 'descending' : 'ascending',
      })
   }
   
   toggleModal = (data, action) => {
      this.setState({
         itemActive:{
            ...this.state.itemActive,
            "nama":data.nama,
            "username":data.username,
            "jabatan":data.datjabatana, 
            "created_at":data.created_at, 
            "public_id":data.public_id
         },
         action: action,
         isOpen: !this.state.isOpen
      });
   }

   handlePaginationChange = (e, { activePage }) => {
      if (this.state.pageActive === activePage){
         return false;
      }

      this.setState({ activePage, pageActive: activePage, requests: true })
      fetch(`${BaseURLDev}/users/opd?page=${activePage}`,{headers})
      .then(response => {
         if (!response.ok) { 
               return Promise.reject(response.statusText);
            }
         return response.json();
      })
      .then(resJSON => {
         this.setState({
            data:resJSON.data,
            totalPages:resJSON.totalPage,
            requests:false
         })
      });
   }

   render() {
      const { requests, column, data, direction } = this.state;

      return (
         <div>
            <Menu>
               <Menu.Item position="right">
                  <Input type="text"
                     icon="search"
                     placeholder="Pencarian ..."
                     autoFocus 
                     value={this.state.q}
                     style={{width:'300px'}}
                     onChange={this.searchOPD} 
                     />
               </Menu.Item>
            </Menu>
            <div>
               <Segment loading={requests}>
                  <Table sortable size='small' celled>
                     <Table.Header>
                     <Table.Row>
                        <Table.HeaderCell>No.</Table.HeaderCell>
                        <Table.HeaderCell>#</Table.HeaderCell>
                        <Table.HeaderCell>Status</Table.HeaderCell>
                        <Table.HeaderCell>Username</Table.HeaderCell>
                        <Table.HeaderCell>NIP</Table.HeaderCell>
                        <Table.HeaderCell>Contact</Table.HeaderCell>
                        <Table.HeaderCell sorted={column === 'nama' ? direction : null} onClick={this.handleSort('nama')}>
                           Nama
                        </Table.HeaderCell>
                        <Table.HeaderCell sorted={column === 'jabatan' ? direction : null} onClick={this.handleSort('jabatan')}>
                           Jabatan
                        </Table.HeaderCell>
                        <Table.HeaderCell>OPD</Table.HeaderCell>
                        <Table.HeaderCell>SKPD</Table.HeaderCell>
                     </Table.Row>
                     </Table.Header>
                     <Table.Body>
                     {_.map(data, (item, i) => (
                        
                        <Table.Row key={i}>
                           <Table.Cell>{i+1+(this.state.activePage-1)*10}</Table.Cell>
                           <Table.Cell style={{textAlign:"center"}}>                           
                              <Button.Group size='mini'>
                                 <Button index={i} title="Edit user"
                                    color='green' icon='pencil' onClick={this.onOpenEdit} />
                                 <Button data={data.length!==0?item.user.username:0}
                                    color='yellow' title="Reset password user"
                                    icon='refresh' onClick={this.resetPassword} />
                                 <Button color='blue' title="Reset status aktif user"
                                    data={data.length!==0?item.user.username:0}
                                    icon='lock' onClick={this.resetStatusActive} />                        
                              </Button.Group>
                           </Table.Cell>
                           <Table.Cell>{item.user.is_active?"Aktif":"Non Aktif"}</Table.Cell>
                           <Table.Cell>{item.user.username}</Table.Cell>
                           <Table.Cell>{item.kode}</Table.Cell>
                           <Table.Cell>{item.contact}</Table.Cell>
                           <Table.Cell>{item.nama}</Table.Cell>
                           <Table.Cell>{item.jabatan}</Table.Cell>
                           <Table.Cell>{
                              getOPD(`${item.kd_urusan}.${item.kd_bidang}.${item.kd_unit}.${item.kd_sub}`)
                           }</Table.Cell>
                           <Table.Cell>{
                              getSKPD(`${item.kd_urusan}.${item.kd_bidang}.${item.kd_unit}`)
                           }</Table.Cell>
                        </Table.Row>
                     ))}
                     </Table.Body>
                     <Table.Footer fullWidth>
                        <Table.Row>
                           <Table.HeaderCell colSpan='10'>
                              <Pagination activePage={this.state.activePage} 
                                 onPageChange={this.handlePaginationChange} 
                                 totalPages={this.state.totalPages}
                              />
                           </Table.HeaderCell>
                        </Table.Row>
                     </Table.Footer>
                  </Table>
               </Segment>
            
            </div>
            <DetailOPD
                  show={this.state.isOpen}
                  onClose={this.toggleModal}
                  itemActive={this.state.itemActive}
                  opt={this.state.action}
               />
            {this.state.is_edit && 
               <ModalEdit 
                  open={this.state.is_edit}
                  data_edit={this.state.data_edit} 
                  onClose={this.onCloseEdit} />
            }
         </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_user/_useropd/ListOPD.js